import React from "react"
import cx from "classnames"
import { ProgressCircular } from "../ProgressCircular"
import { CheckIcon } from "../Icon"

type ProgressBannerPropsType = {
  progress?: {
    done: number
    total: number
  }
  title: string
  description: string
  completed?: boolean
  animated?: boolean
  fullWidth?: boolean
  className?: string
}

export function ProgressBanner({
  progress,
  title,
  description,
  completed = false,
  animated = false,
  fullWidth = false,
  className,
}: ProgressBannerPropsType) {
  return (
    <div
      className={cx("cobalt-progressBanner", className, {
        "cobalt-progressBanner--completed": completed,
        "cobalt-progressBanner--fullWidth": fullWidth,
      })}
    >
      {progress && !completed && (
        <ProgressCircular
          size={48}
          progress={(progress.done * 100) / progress.total}
          animated={animated}
        >
          <div className="cobalt-progressBanner__progress-container">
            {progress.done}/{progress.total}
          </div>
        </ProgressCircular>
      )}

      {completed && (
        <div
          className={cx("cobalt-progressBanner__completed-icon-container", {
            "cobalt-progressBanner__completed-icon-container--animated":
              animated,
          })}
        >
          <CheckIcon color="success" size={32} />
        </div>
      )}

      <div className="cobalt-progressBanner__text-container">
        <div className="cobalt-progressBanner__title">{title}</div>
        <div className="cobalt-progressBanner__description">{description}</div>
      </div>
    </div>
  )
}
